module.exports = __webpack_public_path__ + "img/crane.6754807f.svg";